export default __webpack_public_path__ + "static/media/mediagenix_logo.b452fbcf.svg";